var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5498 20.9851L30.5498 3.77606C30.5498 2.63059 29.9147 1.75569 29.0963 1.19218C28.086 0.496346 27.0508 1.06797 26.2566 1.71302C23.7854 3.72022 20.9853 5.77589 18.5668 7.75763C18.3144 7.96437 18.1158 8.11675 17.8477 8.31782C17.5846 8.51509 17.3774 8.69661 17.1356 8.88502C16.8834 9.08155 16.6918 9.26578 16.3941 9.42283C16.3941 7.58534 16.3871 5.74637 16.3957 3.909C16.4 2.97937 16.0912 2.40849 15.6827 1.86404C15.2608 1.30188 14.6178 0.885586 13.8326 0.885586C12.7548 0.885586 11.0737 2.57046 10.1446 3.25769L6.70838 5.94819C6.13099 6.41712 5.589 6.81866 5.0179 7.28735L3.31632 8.61544C1.72993 9.82412 0.755573 10.3873 0.755573 12.5824C0.755573 14.631 2.59108 15.5206 4.11051 16.7657C4.41166 17.0124 4.6779 17.197 4.98127 17.4433L11.8015 22.809C12.5535 23.4074 13.6993 24.4239 14.9406 23.5691C15.2484 23.3571 15.4591 23.1953 15.6827 22.8973C16.1019 22.3385 16.4003 21.8069 16.3957 20.8523C16.3871 19.0149 16.3941 17.1759 16.3941 15.3384C16.6069 15.3951 16.8394 15.645 17.0973 15.8472C19.7004 17.8866 23.0844 20.4625 25.5461 22.4794C26.4771 23.2424 27.7758 24.4783 29.0962 23.569C29.3858 23.3695 29.6112 23.1979 29.8096 22.936C30.1895 22.4346 30.5497 21.864 30.5497 20.9851L30.5498 20.9851Z",
    fill: "#ADAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.4ec5e00074fae954d480290cba0029b9.svg";
export { ForwardRef as ReactComponent };